import { Emoji } from "emoji-picker-react";
import emojiRegex from "emoji-regex";
import { nameToEmoji } from "gemoji"; // Mapping from names to emoji chars

export const renderTextWithEmojis = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const colonEmojiRegex = /:([a-z0-9_]+):/g; // Detect :emoji_name:

  // Split by URLs first
  const urlParts = text.split(urlRegex);
  const finalParts = [];

  urlParts.forEach((part, i) => {
    if (urlRegex.test(part)) {
      // Render URL as link
      finalParts.push(
        <a
          key={`url-${i}`}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#2563eb", textDecoration: "underline" }}
        >
          {part}
        </a>
      );
    } else {
      // Process emojis and colon-enclosed names in non-URL parts
      const tokens = [];
      let lastIndex = 0;

      // Find all colon-enclosed emojis
      let match;
      while ((match = colonEmojiRegex.exec(part)) !== null) {
        const [fullMatch] = match;
        const index = match.index;

        // Add text before the match
        if (index > lastIndex) {
          tokens.push(part.slice(lastIndex, index));
        }

        // Add the emoji name token (with colons)
        tokens.push(fullMatch);
        lastIndex = index + fullMatch.length;
      }

      // Add remaining text after last match
      if (lastIndex < part.length) {
        tokens.push(part.slice(lastIndex));
      }

      // Process each token
      tokens.forEach((token, j) => {
        // Handle colon-enclosed emoji names (e.g., ":smile:")
        if (colonEmojiRegex.test(token)) {
          const emojiName = token.slice(1, -1); // Remove colons
          const emojiChar = nameToEmoji[emojiName];

          if (emojiChar) {
            // Convert emoji char to unified code
            const unified = Array.from(emojiChar)
              .map((c) => c.codePointAt(0).toString(16))
              .join("-");

            finalParts.push(
              <Emoji
                key={`colon-${i}-${j}`}
                unified={unified}
                size={24}
                style={{
                  display: "inline-block",
                  margin: "0 2px",
                  verticalAlign: "middle",
                }}
              />
            );
          } else {
            // Not a recognized emoji name? Render as text
            finalParts.push(<span key={`text-${i}-${j}`}>{token}</span>);
          }
        }
        // Handle native Unicode emojis
        else {
          const regex = emojiRegex();
          let emojiLastIndex = 0;
          const emojiMatches = [...token.matchAll(regex)];

          if (emojiMatches.length === 0) {
            finalParts.push(<span key={`text-${i}-${j}`}>{token}</span>);
          } else {
            emojiMatches.forEach((match, k) => {
              const emoji = match[0];
              const index = match.index;

              // Text before emoji
              if (index > emojiLastIndex) {
                finalParts.push(
                  <span key={`text-${i}-${j}-${k}`}>
                    {token.slice(emojiLastIndex, index)}
                  </span>
                );
              }

              // Render the emoji
              finalParts.push(
                <Emoji
                  key={`emoji-${i}-${j}-${k}`}
                  unified={Array.from(emoji)
                    .map((c) => c.codePointAt(0).toString(16))
                    .join("-")}
                  size={20}
                  style={{
                    display: "inline-block",
                    // margin: "0 2px",
                    verticalAlign: "middle",
                  }}
                />
              );

              emojiLastIndex = index + emoji.length;
            });

            // Remaining text after last emoji
            if (emojiLastIndex < token.length) {
              finalParts.push(
                <span key={`text-end-${i}-${j}`}>
                  {token.slice(emojiLastIndex)}
                </span>
              );
            }
          }
        }
      });
    }
  });

  return finalParts;
};

export const renderTextWithEmojisActivity = (text) => {
  const regex = emojiRegex(); // Handles ZWJ and complex emoji
  const parts = [];
  let lastIndex = 0;

  // Check if the entire text is just emoji(s)
  const isOnlyEmojis =
    text.match(/^(\s*)([\p{Emoji}\u200d]+)(\s*)$/gu) !== null;

  for (const match of text.matchAll(regex)) {
    const emoji = match[0];
    const index = match.index;

    // Push preceding text
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }

    // Determine size based on whether it's standalone or in text
    const size = isOnlyEmojis ? 20 : 20; // Adjust sizes as needed

    // Push emoji component
    parts.push(
      <Emoji
        key={index}
        unified={Array.from(emoji)
          .map((c) => c.codePointAt(0).toString(16))
          .join("-")}
        size={size}
        style={{
          display: "inline-block",
          margin: "0 2px",
          verticalAlign: "middle",
        }}
      />
    );

    lastIndex = index + emoji.length;
  }

  // Push the remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.map((part, i) =>
    typeof part === "string" ? <span key={i}>{part}</span> : part
  );
};

export const renderTextWithEmojisDms = (text) => {
  const regex = emojiRegex(); // Handles ZWJ and complex emoji
  const parts = [];
  let lastIndex = 0;

  // Check if the entire text is just emoji(s)
  const isOnlyEmojis =
    text.match(/^(\s*)([\p{Emoji}\u200d]+)(\s*)$/gu) !== null;

  for (const match of text.matchAll(regex)) {
    const emoji = match[0];
    const index = match.index;

    // Push preceding text
    if (index > lastIndex) {
      parts.push(text.slice(lastIndex, index));
    }

    // Determine size based on whether it's standalone or in text
    const size = isOnlyEmojis ? 20 : 20; // Adjust sizes as needed

    // Push emoji component
    parts.push(
      <Emoji
        key={index}
        unified={Array.from(emoji)
          .map((c) => c.codePointAt(0).toString(16))
          .join("-")}
        size={size}
        style={{
          display: "inline-block",
          margin: "0 2px",
          verticalAlign: "middle",
        }}
      />
    );

    lastIndex = index + emoji.length;
  }

  // Push the remaining text
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts.map((part, i) =>
    typeof part === "string" ? <span key={i}>{part}</span> : part
  );
};

export const getFirstCodePoint = (emoji) => {
  // For emojis with variation selectors (like ❤️), use the full string
  if (emoji.includes("\ufe0f")) {
    return Array.from(emoji)
      .map((char) => char.codePointAt(0).toString(16))
      .join("-");
  }

  // For composite emojis (like 👩💻), use the full string
  const chars = Array.from(emoji);
  if (chars.length > 1) {
    return chars.map((char) => char.codePointAt(0).toString(16)).join("-");
  }

  // For simple emojis, use the first code point
  return chars[0].codePointAt(0).toString(16);
};
